/*
 * @Author: seven.zhang 
 * @Date: 2019-02-13 14:33:36 
 * @Last Modified by: wyx
 * @Last Modified time: 2019-06-26 18:42:13
 * 路由配置
 */

/**=========================== 全屏部分 =========================== */

// 房企拿地监控系统
const LAND_SYSTEM = r=>require.ensure([], () => r(require('@/pages/fullscreen/landSystem')), 'system');
// 房企项目开工监控系统
const PROJECT_SYSTEM = r=>require.ensure([], () => r(require('@/pages/fullscreen/projectSystem')), 'system');
// 全装修市场监控系统
const MARKET_SYSTEM = r=>require.ensure([], () => r(require('@/pages/fullscreen/marketSystem')), 'system');
// 我的业绩报告
const REPORT_SYSTEM = r=>require.ensure([], () => r(require('@/pages/fullscreen/reportSystem')), 'system');


/**=========================== 列表&&详情 =========================== */

// 列表页&&详情页布局
const PAGE_LAYOUT = r => require.ensure([], () => r(require('@/pages/layout/pageLayout')), 'page');

// 房企拿地列表
const LAND_LIST = r => require.ensure([], () => r(require('@/pages/list/landList')), 'page');
// 房企项目开发监控列表
const PROJECT_LIST = r => require.ensure([], () => r(require('@/pages/list/projectList')), 'page');
// 全装修市场监控列表
const MARKET_LIST = r => require.ensure([], () => r(require('@/pages/list/marketList')), 'page');
// 招标采购列表
const TENDER_LIST = r => require.ensure([], () => r(require('@/pages/list/tenderList')), 'page');

// 详情
const DETAIL = r => require.ensure([], () => r(require('@/pages/detail/detail')), 'page');

// 登录
const LOGIN = r => require.ensure([], () => r(require('@/pages/index/login')), 'page');


// 研究报告
const REPORT_LIST = r => require.ensure([], () => r(require('@/pages/report/index')), 'page');
const REPORT_DETAIL = r => require.ensure([], () => r(require('@/pages/report/detail')), 'page');

// 子账户权限 1:房企拿地监控 2:房企项目 3:全装修 4:招标采购 5:研究报告 6:我的业绩
export default [
    //全屏部分
    { path: '/', component: LAND_SYSTEM, meta:{requireLogin:true,type:[1,2],role:1}},
    
    { path: '/fullscreen/land', component: LAND_SYSTEM, meta:{requireLogin:true,role:1,type:[1,2]}}, // 房企拿地监控系统
    { path: '/fullscreen/project', component: PROJECT_SYSTEM, meta:{requireLogin:true,role:2,type:[1,2]}}, // 房企项目开工监控系统
    { path: '/fullscreen/market', component: MARKET_SYSTEM, meta:{requireLogin:true,role:3,type:[1,2]}}, // 全装修市场监控系统
    { path: '/fullscreen/report', component: REPORT_SYSTEM, meta:{requireLogin:true,role:6,type:[1,2]}}, // 我的业绩报告

    { path: '/login', component: LOGIN, meta:{requireLogin:false,type:[0,1,2]}}, // 登录

    //列表&&详情
    {
        path: '/page',
        component: PAGE_LAYOUT,
        redirect: '/page/land',
        meta:{requireLogin:true},
        children: [
            {path:'land',component:LAND_LIST, meta:{requireLogin:true,role:1,type:[1,2]} },//房企拿地列表
            {path:'project',component:PROJECT_LIST, meta:{requireLogin:true,role:2,type:[1,2]} },//房企项目开发监控列表
            {path:'market',component:MARKET_LIST, meta:{requireLogin:true,role:3,type:[1,2]} },//全装修市场监控列表
            {path:'tender',component:TENDER_LIST, meta:{requireLogin:true,role:4,type:[0,1,2]} },//招标列表
            {path:'detail',component:DETAIL, meta:{requireLogin:true,role:4,type:[0,1,2]} },//详情
            {path:'report',component:REPORT_LIST ,meta:{requireLogin:true,role:5,type:[2]}},//研究报告列表
            {path:'report/detail',component:REPORT_DETAIL,meta:{requireLogin:true,role:5,type:[2]} },//研究报告详情
        ]
    }, 
    
]